export const NetworkLostIcon: React.FC = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3131 3.52152L3.35355 18.4811C3.03857 18.7961 3.26165 19.3346 3.70711 19.3346H18.6667C18.9428 19.3346 19.1667 19.1108 19.1667 18.8346V3.87508C19.1667 3.42962 18.6281 3.20654 18.3131 3.52152Z" stroke="#3E3E3E" stroke-width="1.5"/>
            <circle cx="19" cy="19" r="8" fill="#DC4C4C"/>
            <path d="M16 16L22 22M22 16L16 22" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    )
}